/**
 * @flow
 * @relayHash fc4e3a245af8365451567c31ad244385
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AiSettingsQueryVariables = {||};
export type AiSettingsQueryResponse = {|
  +currentTenant: ?{|
    +customerSettings: ?{|
      +enableAi: boolean
    |}
  |}
|};
export type AiSettingsQuery = {|
  variables: AiSettingsQueryVariables,
  response: AiSettingsQueryResponse,
|};
*/


/*
query AiSettingsQuery {
  currentTenant {
    customerSettings {
      enableAi
      id
    }
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "enableAi",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "AiSettingsQuery",
  "id": "1d2f32220e0f5ea8e8655980e9056c76",
  "text": null,
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "AiSettingsQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "currentTenant",
        "storageKey": null,
        "args": null,
        "concreteType": "TenantType",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "customerSettings",
            "storageKey": null,
            "args": null,
            "concreteType": "CustomerSettingsType",
            "plural": false,
            "selections": [
              v0
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "AiSettingsQuery",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "currentTenant",
        "storageKey": null,
        "args": null,
        "concreteType": "TenantType",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "customerSettings",
            "storageKey": null,
            "args": null,
            "concreteType": "CustomerSettingsType",
            "plural": false,
            "selections": [
              v0,
              v1
            ]
          },
          v1
        ]
      }
    ]
  }
};
})();
node.text = "query AiSettingsQuery {\n  currentTenant {\n    customerSettings {\n      enableAi\n      id\n    }\n    id\n  }\n}\n";
(node/*: any*/).hash = '64c8d216ff466b89598285390780e29b';
module.exports = node;
